module.exports = __webpack_public_path__ + "media/images/cms/logo_brand_dummy-804cbee193c2cdbc9bb327b8177fe9b5.png";